import {
  supplierInstallationEmissionReportProductionRouteValues,
  type SupplierInstallationEmissionReportProductionRoute,
} from '@artem-cbam-operator/common-server/supplier-installation-emission-report'
import type { TFunction } from 'i18next'

export { supplierInstallationEmissionReportProductionRouteValues }

export function formatSupplierInstallationEmissionReportProductionRouteLabel(
  route: SupplierInstallationEmissionReportProductionRoute,
  t: TFunction<'installations'>
): string {
  return `${route} — ${t(`productionRoutes.${route}`)}`
}
